module.exports = __webpack_public_path__ + "static/media/close.535a1e31.svg";